import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DealSaveStateService {
  private savingDealSubject = new BehaviorSubject<boolean>(false);
  isSavingDeal$ = this.savingDealSubject.asObservable();

  setSavingDeal(isSaving: boolean) {
    this.savingDealSubject.next(isSaving);
  }

  getSavingDeal(): boolean {
    return this.savingDealSubject.value;
  }
}
